import React, { forwardRef } from 'react'
import styled from 'styled-components'
import {
  compose,
  grid,
  GridProps as BaseGridProps,
  space,
  SpaceProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps
} from 'styled-system'

export interface GridItemProps extends BaseGridProps,
  React.HTMLAttributes<HTMLDivElement>, SpaceProps, FlexboxProps, LayoutProps { }

const StyledGridItem = styled.div<BaseGridProps>`
  ${compose(grid, space, flexbox, layout)}
`

const GridItem = forwardRef<HTMLDivElement, GridItemProps>(({
  children, ...props
}: GridItemProps, ref) => (
  <StyledGridItem ref={ref} {...props}>{children}</StyledGridItem>
))

export default GridItem
